<section>
    <app-navbar></app-navbar>
</section>
<app-bottom-navbar></app-bottom-navbar>